export default {
  backend_api_url: "https://vtubers-api.herokuapp.com/api/v1",
  frontend_base_url: "https://vtubers.love"
};
